import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const transactionsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.TRANSACTIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.TRANSACTIONS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.TRANSACTIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const transactionReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.TRANSACTION_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.TRANSACTION_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.TRANSACTION_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { transactionsReducer, transactionReducer };
